import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const stats = [{
    label: '5★ Rated'
  }, {
    label: '500+ Homes Treated'
  }, {
    label: '100% Satisfaction'
  }];
  const sectionRef = useRef<HTMLElement>(null);
  const logoRef = useRef<HTMLImageElement>(null);
  const posRef = useRef({
    x: 200,
    y: 100
  });
  const velRef = useRef({
    dx: 1.2,
    dy: 0.8
  });
  const frameRef = useRef<number>(0);
  useEffect(() => {
    const animate = () => {
      const section = sectionRef.current;
      const logo = logoRef.current;
      if (!section || !logo) {
        frameRef.current = requestAnimationFrame(animate);
        return;
      }
      const sW = section.offsetWidth;
      const sH = section.offsetHeight;
      const logoSize = window.innerWidth >= 768 ? 400 : 250;
      let {
        x,
        y
      } = posRef.current;
      let {
        dx,
        dy
      } = velRef.current;
      x += dx;
      y += dy;
      if (x <= 0) {
        x = 0;
        dx = Math.abs(dx);
      }
      if (x + logoSize >= sW) {
        x = sW - logoSize;
        dx = -Math.abs(dx);
      }
      if (y <= 0) {
        y = 0;
        dy = Math.abs(dy);
      }
      if (y + logoSize >= sH) {
        y = sH - logoSize;
        dy = -Math.abs(dy);
      }
      posRef.current = {
        x,
        y
      };
      velRef.current = {
        dx,
        dy
      };
      logo.style.left = `${x}px`;
      logo.style.top = `${y}px`;
      frameRef.current = requestAnimationFrame(animate);
    };
    frameRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameRef.current);
  }, []);
  return <section ref={sectionRef} className="relative min-h-screen bg-brand-black overflow-hidden flex items-center pt-24 pb-32 md:pt-20 md:pb-20" data-id="element-164">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-100" data-id="element-165" />
      <div className="absolute top-0 right-0 w-[400px] md:w-[800px] h-[400px] md:h-[800px] bg-brand-green/8 rounded-full blur-[120px] translate-x-1/4 -translate-y-1/4 pointer-events-none" data-id="element-166" />

      {/* Bouncing Ghost Logo */}
      <img ref={logoRef} src="https://cdn.magicpatterns.com/uploads/iTHV1zi5LbUMvL5bFz6T1i/pestco.webp" alt="" className="absolute w-[250px] h-[250px] md:w-[400px] md:h-[400px] opacity-[0.06] animate-rotate-slow pointer-events-none" style={{
      left: '200px',
      top: '100px'
    }} aria-hidden="true" data-id="element-167" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 w-full relative z-10" data-id="element-168">
        <div className="max-w-4xl" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="flex flex-col leading-[0.85] mb-6" data-id="element-170">
            <h1 className="text-[56px] sm:text-7xl md:text-[140px] text-white" data-id="element-171">
              ULTIMATE
            </h1>
            <h1 className="text-[56px] sm:text-7xl md:text-[140px] text-brand-green" data-id="element-172">
              PEST
            </h1>
            <h1 className="text-[56px] sm:text-7xl md:text-[140px] text-stroke-white-2" data-id="element-173">
              CONTROL
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="font-barlow text-base sm:text-xl md:text-2xl text-brand-gray max-w-2xl mb-8 md:mb-10" data-id="element-174">
            We don't just treat pest problems — we eliminate them for good.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.9,
          duration: 0.8
        }} className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-175">
            <button onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })} className="bg-brand-green text-black font-bold px-6 sm:px-8 py-3 sm:py-4 clip-parallelogram hover:bg-white transition-colors font-condensed uppercase tracking-wide text-lg sm:text-xl text-center" data-id="element-176">
              Get a Free Quote
            </button>
            <button onClick={() => document.getElementById('services')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })} className="border-2 border-white text-white bg-transparent px-6 sm:px-8 py-3 sm:py-4 clip-parallelogram hover:bg-white/10 transition-colors font-condensed uppercase tracking-wide text-lg sm:text-xl text-center" data-id="element-177">
              Our Services
            </button>
          </motion.div>
        </div>
      </div>

      {/* Stats */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1.5,
      duration: 0.8
    }} className="absolute bottom-6 left-4 right-4 flex flex-wrap justify-center gap-2 md:justify-end md:left-auto md:right-12 md:bottom-10 md:gap-3" data-id="element-178">
        {stats.map((stat, i) => <div key={i} className="bg-brand-dark border border-white/10 px-3 py-1.5 md:px-4 md:py-2 rounded-full" data-id="element-179">
            <span className="font-condensed uppercase text-white tracking-wider text-xs md:text-sm" data-id="element-180">
              {stat.label}
            </span>
          </div>)}
      </motion.div>
    </section>;
}